import React, { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { API_BASE_URL } from "./apiConfig";

const Login = () => {
  const navigate = useNavigate();
  const [clientId, setClientId] = useState("1");
  const [userId, setUserId] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  const handleLogin = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    setError("");

    try {
      const res = await fetch(`${API_BASE_URL}/auth/login`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          Client_ID: Number(clientId),
          User_ID: Number(userId),
          Password: password,
        }),
      });

      if (!res.ok) {
        setError("Invalid Client ID, User ID or Password. Please try again.");
        setIsLoading(false);
        return;
      }

      const data = await res.json();

      // Store the session: token + identifying ids, used on every request from now on
      // NOTE: reading from data.userName / data.role / data.clientId / data.companyId /
      // data.userId here, since the backend now returns explicit lowerCamelCase keys.
      localStorage.setItem(
        "courier_session",
        JSON.stringify({
          token: data.token,
          User_Name: data.userName,
          Role: data.role,
          Client_ID: data.clientId,
          Company_ID: data.companyId,
          User_ID: data.userId,
        })
      );

      navigate("/admin");
    } catch (err) {
      setError("Unable to reach server. Please try again.");
      setIsLoading(false);
    }
  };

  return (
    <div className="login-isolated-container">
      <style>{`
        .login-isolated-container {
          min-height: 100vh;
          display: flex;
          align-items: center;
          justify-content: center;
          background-color: #f3f4f6;
          font-family: system-ui, -apple-system, sans-serif;
          margin: 0;
          padding: 0;
        }
        .login-card {
          background: white;
          padding: 2.5rem;
          border-radius: 12px;
          box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1);
          width: 100%;
          max-width: 400px;
        }
        .login-header { text-align: center; margin-bottom: 2rem; }
        .login-header h1 { color: #1f2937; font-size: 1.5rem; margin: 0 0 0.5rem 0; }
        .login-header p { color: #6b7280; font-size: 0.875rem; margin: 0; }
        .login-form-group { margin-bottom: 1.25rem; }
        .login-form-group label { display: block; font-size: 0.875rem; color: #374151; margin-bottom: 0.375rem; }
        .login-form-group input {
          width: 100%; padding: 0.625rem 0.875rem; border: 1px solid #d1d5db;
          border-radius: 8px; font-size: 0.9375rem; box-sizing: border-box;
        }
        .login-error { color: #dc2626; font-size: 0.8125rem; margin-bottom: 1rem; }
        .login-submit-btn {
          width: 100%; padding: 0.75rem; background: #2563eb; color: white;
          border: none; border-radius: 8px; font-size: 0.9375rem; cursor: pointer;
        }
        .login-submit-btn:disabled { opacity: 0.6; cursor: not-allowed; }
        .login-back-link { text-align: center; margin-top: 1.25rem; font-size: 0.875rem; }
        .login-back-link a { color: #2563eb; text-decoration: none; }
      `}</style>

      <div className="login-card">
        <div className="login-header">
          <h1>Portal Login</h1>
          <p>Sign in to access the admin dashboard</p>
        </div>

        <form onSubmit={handleLogin}>
          <div className="login-form-group">
            <label htmlFor="clientId">Client ID</label>
            <input
              id="clientId"
              type="number"
              value={clientId}
              onChange={(e) => setClientId(e.target.value)}
              required
            />
          </div>
          <div className="login-form-group">
            <label htmlFor="userId">User ID</label>
            <input
              id="userId"
              type="number"
              value={userId}
              onChange={(e) => setUserId(e.target.value)}
              required
            />
          </div>
          <div className="login-form-group">
            <label htmlFor="password">Password</label>
            <input
              id="password"
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
            />
          </div>

          {error && <p className="login-error">{error}</p>}

          <button type="submit" className="login-submit-btn" disabled={isLoading}>
            {isLoading ? "Signing in..." : "Sign In"}
          </button>
        </form>

        <div className="login-back-link">
          <Link to="/">← Back to Home</Link>
        </div>
      </div>
    </div>
  );
};

export default Login;